import React, { useState } from "react";
import Navbar from "../../components/common/Navbar";
import Footer from "../../components/common/Footer";
import useFetch from "../../hooks/useFetch";
import { useParams } from "react-router-dom";
import { LongDate } from "../../utils/LongDate";
import BulletinBanner from "../../components/user/BulletinBanner";

const UserFeaturedBulletinPage = () => {
  const { id } = useParams();
  const API_URL = process.env.REACT_APP_API_URL;
  const { data: featuredBulletin } = useFetch(`${API_URL}/bulletin/${id}`);
  const { data: otherStories } = useFetch(`${API_URL}/bulletins/${id}`);

  const [showFullDescription, setShowFullDescription] = useState(false);

  // Get the first image from the file_name field
  const firstImage = featuredBulletin?.file_name
    ? featuredBulletin.file_name.split(",")[0]
    : "";
  const remainingImages = featuredBulletin?.file_name
    ? featuredBulletin.file_name.split(",").slice(1)
    : [];

  // Function to get image path
  const getImagePath = (fileName) => {
    return `/uploads/bulletin/${fileName}`;
  };

  return (
    <>
      <Navbar />
      <div className="mt-[60px] w-full h-auto">
        <BulletinBanner />
        <div className="flex flex-col md:flex-row gap-10 h-auto w-full lg:p-20 px-8 py-10">
          {featuredBulletin && (
            <div
              className="flex flex-col gap-5 lg:w-[862px] items-center cursor-pointer"
              onClick={() => setShowFullDescription(!showFullDescription)}
            >
              <img
                className="rounded-[2rem] md:h-[656px] w-full object-cover"
                src={getImagePath(firstImage)}
                alt={featuredBulletin.header_name}
              />
              <div className="flex flex-col gap-2 w-full mt-3">
                <p className="md:text-xl text-base">
                  {LongDate(featuredBulletin.event_date)}
                </p>
                <h1 className="font-bold md:text-[32px] text-[20px]">
                  {featuredBulletin.header_name}
                </h1>
                <p
                  className={`text-base md:text-xl ${
                    !showFullDescription ? "line-clamp-4" : ""
                  }`}
                >
                  {featuredBulletin.description}
                  {showFullDescription &&
                    remainingImages.map((fileName, index) => (
                      <div className="bg-white py-5" key={index}>
                        <div className="flex flex-row w-full justify-center items-center">
                          <img
                            className="rounded-[2rem] w-full object-cover"
                            src={getImagePath(fileName)}
                            alt={`${featuredBulletin?.header_name} ${
                              index + 1
                            }`}
                          />
                        </div>
                      </div>
                    ))}
                </p>
              </div>
            </div>
          )}
          {otherStories.length > 0 && (
            <div className="flex flex-col lg:w-[362px] md:w-[181px] bg-[#ECECEC] h-auto md:max-h-[1119px] rounded-lg shadow-md">
              <h1 className="md:text-[20px] text-xl font-bold text-start p-5">
                Other Stories
              </h1>
              <div className="flex flex-col justify-center items-center gap-5">
                {otherStories.slice(0, 3).map((row, index) => (
                  <div
                    key={index}
                    className="flex flex-col justify-center items-center gap-5 w-full lg:w-[286px] p-2 rounded-xl"
                  >
                    <div className="lg:w-[286px] md:w-[143px] w-full">
                      <img
                        className="lg:h-[204px] h-auto lg:w-[286px] md:w-[143px] rounded-lg object-cover"
                        src={getImagePath(row.file_name.split(",")[0])}
                        alt={row.header_name}
                      />
                    </div>
                    <div className="flex flex-col gap-2 lg:w-[286px] md:w-[143px] w-full">
                      <h1 className="md:text-base text-xl font-bold">
                        {row.header_name}
                      </h1>
                      <p className="line-clamp-2 text-[13px] md:text-[15px]">
                        {row.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserFeaturedBulletinPage;
